module.exports = __webpack_public_path__ + "img/04.872d0abf.jpg";